export const WIZARD_PROGRESS = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CONFIRMED: 'Confirmed',
  FAILED: 'Failed',
  INCOMPLETE: 'Incomplete'
};
